import React from 'react'
import TourCompletionStepper from '../components/tourCompletion/TourCompletionStepper'

const TourComplete = () => {
  return (
    <div className='outletContainer'><TourCompletionStepper /></div>
  )
}

export default TourComplete